import React, { useEffect, useMemo, useRef } from "react";
import { useCompetition } from "../../../../context/CompetitionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { useTermsModal } from "../../../../context/TermsModalContext";
import { useToast } from "../../../../context/ToastContext";
import { getTermsPdfUrl } from "../../../../utils/api";

/**
 * Opens the competition terms PDF from the backend in the same tab.
 * Only runs when the user clicks "See how it works" (open flips to true).
 */
const TermsModal = () => {
  const { open, closeTerms } = useTermsModal();
  const { t, locale } = useLanguage();
  const { showToast } = useToast();
  const { competition, competitionId } = useCompetition();
  const wasOpenRef = useRef(false);

  const pdfUrl = useMemo(() => {
    const rawId = competitionId || competition?.id || null;
    const id =
      rawId && String(rawId) !== "static-demo" ? rawId : undefined;

    return getTermsPdfUrl(id, locale);
  }, [competition, competitionId, locale]);

  useEffect(() => {
    // Fire only on the transition false → true (button click), not on language/route updates.
    if (!open) {
      wasOpenRef.current = false;
      return;
    }
    if (wasOpenRef.current) return;
    wasOpenRef.current = true;

    closeTerms();

    if (pdfUrl) {
      window.location.assign(pdfUrl);
      return;
    }

    showToast(t("terms.unavailable"), "warning");
  }, [open, pdfUrl, closeTerms, showToast, t]);

  return null;
};

export default TermsModal;
